import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticateResultModel } from '@shared/service-proxies/service-proxies';
import { LoginComponent } from 'account/login/login.component';
import { LoginService } from 'account/login/login.service';
import { ResetPasswordModel } from 'account/password/reset-password.model';
import { ResetPasswordComponent } from 'account/password/reset-password.component';
import { SendTwoFactorCodeComponent } from 'account/login/send-two-factor-code.component';
import { ValidateTwoFactorCodeComponent } from 'account/login/validate-two-factor-code.component';

@Component({
  selector: 'app-webfacing-login',
  templateUrl: './webfacing-login.component.html',
  styleUrls: ['./webfacing-login.component.css'],
  standalone: true,
  imports: [LoginComponent, CommonModule, ResetPasswordComponent, SendTwoFactorCodeComponent, ValidateTwoFactorCodeComponent]
})
export class WebfacingLoginComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal, public loginService: LoginService, private router: Router) { }
  step: number = 1;
  model: ResetPasswordModel = new ResetPasswordModel()
  ngOnInit() {
    this.loginService.loginResult$.subscribe((result: AuthenticateResultModel) => {
      if (result.shouldResetPassword || result.requiresTwoFactorVerification) {
        if (result.requiresTwoFactorVerification) {
          this.step = 2;
        }
        else if (result.shouldResetPassword) {
          this.model.userId = result.userId;
          this.model.resetCode = result.passwordResetCode;
          this.model.tenantId = "1";
          this.step = 4;
        }
      } else if (result.accessToken) {
        this.activeModal.close(result);
        //if (this.isCalculationPage(this.router.url)) {
        window.location.reload();
        //}

      }
    });
  }

  isCalculationPage(url: string): boolean {
    const reportUrls = ['/cable-sizing-as', '/cable-sizing-bs', '/cable-sizing-nz', '/cable-pulling', '/arc-flash', '/max-demand', '/protection-coordination', '/cable-sizing-iec', '/cable-sizing-nec'];
    return reportUrls.some(route => url.includes(route));
  }

  updateStep(step: number): void {
    this.step = step;
  }
}
